import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Messages
 */
export const MarkAllMessagesAsReadContentType = '' as const;
export type MarkAllMessagesAsReadRequest = void;
export type MarkAllMessagesAsReadResponses = LinkCommonErrorResponses & {
    /**
     * @description All messages marked as read successfully
     */
    '200': {};
};
export type MarkAllMessagesAsReadResponseSuccess = undefined;
export type MarkAllMessagesAsReadSearchParams = undefined;
export type MarkAllMessagesAsReadPathParameters = undefined;
export const MarkAllMessagesAsReadUrl = '/messages/mark_all_read' as const;
export const MarkAllMessagesAsReadMethod = 'POST' as const;
export const getMarkAllMessagesAsReadUrl = (_params?: MarkAllMessagesAsReadPathParameters) => MarkAllMessagesAsReadUrl;
